module.exports = __webpack_public_path__ + "img/icon_category_06_w.8cec63a3.svg";